
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/edit",
      function () {
        return require("private-next-pages/company/edit.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/company/edit"])
      });
    }
  